export { default } from './MoneyDisplay';
